import { useIonViewWillLeave } from "@ionic/react";
import { useQueryClient } from "@tanstack/react-query";
import { useRouteMatch } from "react-router-dom";
import { greeterEventKeys } from "@greeter-venue/api/QueryKeys";
import { Routes } from "@greeter-venue/utility/Routes";
import { EditEventPageV2 } from "./EditEventPageV2";
import { useSearchParams } from "@greeter/url";
import { useGreeterVenueApi } from "@greeter/matter";

type Params = {
  id?: string;
};

export function EditEventPageApiHandler() {
  const routeMatch = useRouteMatch<Params>(
    Routes.mainGroup.editEvent.template()
  );
  const greeterEventId = routeMatch?.params.id;
  const searchParams = useSearchParams();
  const duplicating = Boolean(searchParams.get("duplicating") ?? false);

  const { api: venueProxy } = useGreeterVenueApi();
  const queryClient = useQueryClient();

  useIonViewWillLeave(() => {
    queryClient.invalidateQueries({ queryKey: greeterEventKeys.all() });
  });

  return (
    <EditEventPageV2
      greeterEventId={greeterEventId}
      api={venueProxy}
      duplicating={duplicating}
    />
  );
}
